import { render, staticRenderFns } from "./HolderNew.vue?vue&type=template&id=5f5a26c4&scoped=true&"
import script from "./HolderNew.vue?vue&type=script&lang=ts&"
export * from "./HolderNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5a26c4",
  null
  
)

export default component.exports